import { render, staticRenderFns } from "./noLanding.vue?vue&type=template&id=c6ced83e&scoped=true&"
import script from "./noLanding.vue?vue&type=script&lang=js&"
export * from "./noLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ced83e",
  null
  
)

export default component.exports